import { render, staticRenderFns } from "./StudentProfileFormWizard.vue?vue&type=template&id=3358caac"
import script from "./StudentProfileFormWizard.vue?vue&type=script&lang=js"
export * from "./StudentProfileFormWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports